import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';
import { CATEGORY_ID } from '../constants/category';
import { sortDataSearch, decimalToBinary } from '../functions/utils';
import { PAGING_DEFAULT } from '../constants/constants';

export default function dateFinderReducer(state = initialState.dateFinderState, action) {
  switch (action.type) {
    case types.UPDATE_STATE_DATE_FINDER_SUCCESS: {
      return state.merge({ ...action.data });
    }
    case types.ADD_DATE_FINDER_DESCRIPTIONS_SUCCESS: {
      return state.set('descriptions', action.descriptions);
    }
    case types.ADD_DATE_FINDER_MEETING_TYPES_SUCCESS: {
      const meetingTypesFilter = action.meetingTypes.map((i, idx) => {
        i.active = idx === 0;
        return i;
      });
      state = state.setIn(['filter', 'arrMeetingType'], meetingTypesFilter).setIn(['defaultFilter', 'arrMeetingType'], meetingTypesFilter);
      return state;
    }
    case types.UPDATE_MEMBER_TYPE_STATE_DATE_FINDER: {
      const { flag, index } = action;
      state = state.setIn(['filter', 'showMeMemberType', 'contentTabs', 0, 'data', index, 'active'], flag);
      return state;
    }
    case types.UPDATE_MEMBER_TYPE_STATE_ADD_DATE_FINDER: {
      const { flag, index } = action;
      state = state.setIn(['addDateFilter', 'showMeMemberType', 'contentTabs', 0, 'data', index, 'active'], flag);
      return state;
    }
    case types.UPDATE_QUICK_SELECT_DATE_DATE_FINDER: {
      return state.set('quickDateFilter', action.date);
    }
    case types.UPDATE_QUICK_SELECT_LOCATION_DATE_FINDER: {
      return state.set('quickFilterLocationDateFilter', action.location);
    }
    case types.GET_LIST_ENTITIES_SUCCESS: {
      const { categoryId, data } = action;
      const {
        filter,
        filter: {
          showMeMemberType: { contentTabs },
        },
        defaultFilter,
        isGetMemberType,
      } = Immutable.asMutable(state);
      let updateObject = {};
      if (categoryId === CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE && !isGetMemberType) {
        updateObject = {
          isGetMemberType: true,
          filter: {
            ...filter,
            showMeMemberType: {
              contentTabs: [
                {
                  data: [...data.items, ...contentTabs[0].data],
                },
              ],
            },
          },
          defaultFilter: {
            ...defaultFilter,
            showMeMemberType: {
              contentTabs: [
                {
                  data: data.items,
                },
              ],
            },
          },
        };
      }
      return state.merge({ ...updateObject });
    }
    case types.DATE_FINDER_SEARCH: {
      const { filter, defaultFilter } = Immutable.asMutable(state);
      const { dates, countSummary, searchCriteria, params } = action;
      let updateObject = {
        countSummary,
        dates: sortDataSearch(dates, true),
        isFetchingDates: false,
        isLoadedSearchData: true,
        isHasMoreDates: params && params.size ? dates && dates.length === params.size : dates && dates.length === 50,
      };
      if (searchCriteria) {
        let memberType = filter.showMeMemberType.contentTabs[0].data;
        if (searchCriteria.seekingTypes && memberType) {
          const powArr = decimalToBinary(searchCriteria.seekingTypes);
          memberType = memberType.map(item => {
            const idx = powArr ? powArr.indexOf(item.id) : -1;
            if (idx !== -1) {
              return { ...item, active: true };
            }
            return { ...item, active: false };
          });
        }

        updateObject = {
          ...updateObject,
          filter: {
            ...filter,
            ageMax: searchCriteria.ageMax,
            ageMin: searchCriteria.ageMin,
            googleMapPlaceID: searchCriteria.googleMapPlaceID,
            searchRadius: searchCriteria.searchRadius,
            seekingTypes: searchCriteria.seekingTypes,
            showMeMemberType: {
              contentTabs: [
                {
                  data: memberType,
                },
              ],
            },
            withPhoto: searchCriteria.withPhoto,
            isHasChangeFilter: filter.isHasChangeFilter,
            isDoFilter: false,
          },
          defaultFilter: {
            ...defaultFilter,
            ageMax: searchCriteria.ageMax,
            ageMin: searchCriteria.ageMin,
            googleMapPlaceID: searchCriteria.googleMapPlaceID,
            searchRadius: searchCriteria.searchRadius,
            seekingTypes: searchCriteria.seekingTypes,
            showMeMemberType: {
              contentTabs: [
                {
                  data: memberType,
                },
              ],
            },
            withPhoto: searchCriteria.withPhoto,
            isHasChangeFilter: false,
            isDoFilter: false,
          },
          addDateFilter: {
            ...defaultFilter,
            ageMax: searchCriteria.ageMax,
            ageMin: searchCriteria.ageMin,
            googleMapPlaceID: searchCriteria.googleMapPlaceID,
            searchRadius: searchCriteria.searchRadius,
            seekingTypes: searchCriteria.seekingTypes,
            showMeMemberType: {
              contentTabs: [
                {
                  data: memberType,
                },
              ],
            },
            withPhoto: searchCriteria.withPhoto,
          },
        };
      }
      return state.merge({ ...updateObject });
    }

    case types.DATE_FINDER_SUGGESTED: {
      return state.merge({
        datesSuggested: sortDataSearch(action.dates, true),
        isFetchingDates: false,
        countSummary: action.countSummary,
      });
    }

    case types.GET_MORE_DATE_FINDER_SUCCESS: {
      const { dates } = Immutable.asMutable(state);
      let isHasMoreDates = false;
      if (action.params && action.params.size) {
        isHasMoreDates = action.dates && action.dates.length === action.params.size;
      } else {
        isHasMoreDates = action.dates && action.dates.length === 50;
      }
      const updateObject = {
        dates: sortDataSearch(action.dates, true),
        isFetchingDates: false,
        isHasMoreDates,
      };
      if (dates.length > 0) {
        const lastDateOfOldData = dates[dates.length - 1];
        const firstDateOfNewDate = updateObject.dates[0];
        let newDate = [];
        if (lastDateOfOldData.title === firstDateOfNewDate.title) {
          const dateNotExists = [];
          firstDateOfNewDate.data.forEach(itm => {
            const indexExists = lastDateOfOldData.data.findIndex(lastItem => lastItem.id === itm.id);
            if (indexExists === -1) {
              dateNotExists.push(itm);
            }
          });
          firstDateOfNewDate.data = [...lastDateOfOldData.data, ...dateNotExists];

          newDate = dates.filter((itm, idx) => idx < dates.length - 1);
          newDate = [...newDate, { ...firstDateOfNewDate }];
          newDate = [...newDate, ...updateObject.dates.filter((itm, idx) => idx !== 0)];
        } else {
          newDate = [...dates, ...updateObject.dates];
        }

        updateObject.dates = newDate;
      }

      return state.merge({ ...updateObject });
    }

    case types.GET_MY_DATE_FINDER_SUCCESS: {
      const { dataListMyDate, totalMyDateFinder } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingListMyDate: false,
        dataListMyDate: action.params && action.params.isLoadMore ? [...dataListMyDate, ...action.data] : action.data,
        isHasMoreListMyDate: false,
        findGreatIdealModal: [...dataListMyDate, ...action.data].length === 0 || false,
      };
      return state.merge({ ...updateParams }).set('isLoadedMyDate', true);
    }

    case types.GET_DETAIL_DATE_FINDER_SUCCESS: {
      const { dataDetailDate } = Immutable.asMutable(state);
      const updateObj = action.params ? { [action.params.id]: action.data } : {};
      return state.merge({
        dataDetailDate: { ...dataDetailDate, ...updateObj },
        isLoadingDetailDate: false,
      });
    }

    case types.DELETE_MY_DATE_FINDER_SUCCESS: {
      const { dataListMyDate } = Immutable.asMutable(state);
      if (action.listId.length < 0) {
        return state;
      }
      const newDate = dataListMyDate.filter(item => item.id !== action.listId[0]);
      return state.merge({ dataListMyDate: newDate }).set('findGreatIdealModal', newDate.length === 0);
    }

    case types.GET_DATE_FINDER_INTERESTS_SUCCESS: {
      const { dataDateInterests } = Immutable.asMutable(state);
      const updateParams = {
        isLoadingDateInterest: false,
        dataDateInterests: action.params && action.params.isLoadMore ? [...dataDateInterests, ...action.data] : action.data,
        isHasMoreDateInterest: !(action.data instanceof Array && action.data.length < PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH),
      };
      return state.merge({ ...updateParams });
    }

    case types.POST_CREATE_DATE_FINDER_SUCCESS: {
      const { dataListMyDate } = Immutable.asMutable(state);
      const newDataListMyDate = [...dataListMyDate, ...action.data];
      state = state.set('dataListMyDate', newDataListMyDate);
      return state.set('findGreatIdealModal', newDataListMyDate.length === 0);
    }

    case types.PATCH_DATE_FINDER_INTEREST_SUCCESS: {
      const { dataDetailDate, datesSuggested, dates } = Immutable.asMutable(state);
      if (action.indexDateFinder !== undefined && action.indexSection !== undefined) {
        const { indexSection, indexDateFinder, id } = action;
        if (dates && dates.length > 0) {
          const existsDateFinderOnListDates =
            dates[indexSection] && dates[indexSection].data && dates[indexSection].data[indexDateFinder] && dates[indexSection].data[indexDateFinder].id === id;
          state = existsDateFinderOnListDates ? state.setIn(['dates', action.indexSection, 'data', action.indexDateFinder, 'hasExpressedInterest'], true) : state;
        }
        if (datesSuggested && datesSuggested.length > 0) {
          const existsDateFinderOnDatesSuggested =
            datesSuggested[indexSection] &&
            datesSuggested[indexSection].data &&
            datesSuggested[indexSection].data[indexDateFinder] &&
            datesSuggested[indexSection].data[indexDateFinder].id === id;
          state = existsDateFinderOnDatesSuggested ? state.setIn(['datesSuggested', action.indexSection, 'data', action.indexDateFinder, 'hasExpressedInterest'], true) : state;
        }
      }
      if (!dataDetailDate[action.id]) {
        return state;
      }
      return state.setIn(['dataDetailDate', action.id.toString(), 'hasExpressedInterest'], true);
    }

    case types.PATCH_DATE_FINDER_UN_INTEREST_SUCCESS: {
      const { dataDetailDate, datesSuggested, dates } = Immutable.asMutable(state);
      if (action.indexDateFinder !== undefined && action.indexSection !== undefined) {
        const { indexSection, indexDateFinder, id } = action;
        if (dates && dates.length > 0) {
          const existsDateFinderOnListDates =
            dates[indexSection] && dates[indexSection].data && dates[indexSection].data[indexDateFinder] && dates[indexSection].data[indexDateFinder].id === id;
          state = existsDateFinderOnListDates ? state.setIn(['dates', action.indexSection, 'data', action.indexDateFinder, 'hasExpressedInterest'], false) : state;
        }
        if (datesSuggested && datesSuggested.length > 0) {
          const existsDateFinderOnDatesSuggested =
            datesSuggested[indexSection] &&
            datesSuggested[indexSection].data &&
            datesSuggested[indexSection].data[indexDateFinder] &&
            datesSuggested[indexSection].data[indexDateFinder].id === id;
          state = existsDateFinderOnDatesSuggested ? state.setIn(['datesSuggested', action.indexSection, 'data', action.indexDateFinder, 'hasExpressedInterest'], false) : state;
        }
      }
      if (!dataDetailDate[action.id]) {
        return state;
      }
      return state.setIn(['dataDetailDate', action.id.toString(), 'hasExpressedInterest'], false);
    }

    case types.TOGGLE_ADD_DATE_MODAL: {
      return state.set('showAddDateModal', action.status);
    }

    case types.TOGGLE_SINGLE_DATE_MODAL: {
      return state.set('isShowSingleSelectDate', action.status);
    }

    case types.TOGGLE_SINGLE_DATE_CUSTOME_MODAL: {
      return state.set('isShowSingleSelectDate', action.status).set('disableDefaultSelectDate', action.status);
    }

    case types.SET_QUICK_DATE_SUCCESS: {
      return state.set('quickDateSelect', action.date);
    }

    case types.TOGGLE_MY_DATE_MODAL: {
      return state.set('isShowAllMyDates', action.status);
    }

    case types.TOGGLE_GREAT_IDEAL: {
      return state.set('isShowGreatIdealModal', action.status);
    }

    // case types.GET_USER_SEARCH_SETTINGS_SUCCESS: {
    //     let {filter, defaultFilter} = Immutable.asMutable(state);
    //     return state.merge({
    //         filter: {
    //             ...filter,
    //             ...action.data.filters
    //         },
    //         defaultFilter: {
    //             ...defaultFilter,
    //             ...action.data.filters
    //         }
    //     });
    // }

    // eslint-disable-next-line no-case-declarations
    case types.DATE_FINDER_BLOCK_USER_SUCCESS:
      const { dataDateInterests, dataListMyDate } = Immutable.asMutable(state);
      const newUserInterest = dataDateInterests.filter(user => user.profile.userId !== action.params.userId);
      state = state.merge({
        dataDateInterests: newUserInterest,
      });
      const indexMyDate = dataListMyDate.findIndex(itm => itm.id === action.params.idMyDate);
      if (dataListMyDate && indexMyDate !== -1) {
        state = state.setIn(['dataListMyDate', indexMyDate, 'interestCount'], dataListMyDate[indexMyDate].interestCount - 1);
      }

      return state;
    case types.HANDLE_DATE_FINDER_MEETING_TYPES: {
      const { filter } = Immutable.asMutable(state);
      const { index, value } = action;
      if (index === 0) {
        let array = [];
        try {
          array = filter.arrMeetingType.map((i, idx) => {
            if (idx === index) {
              return { ...i, active: true };
            }
            return { ...i, active: false };
          });
          return state.merge({
            filter: {
              ...filter,
              arrMeetingType: array,
            },
          });
        } catch (e) {
          return state;
        }
      }
      return state.setIn(['filter', 'arrMeetingType', 0, 'active'], false).setIn(['filter', 'arrMeetingType', index, 'active'], value);
    }
    case types.UPDATE_HAS_CHANGE_FILTERS_STATUS: {
      const { value } = action;
      return state.setIn(['filter', 'isHasChangeFilter'], value);
    }
    case types.UPDATE_SEARCH_DATE_FINDER_STATUS: {
      const { value } = action;
      return state.setIn(['filter', 'isDoFilter'], value);
    }
    case types.EDIT_MY_DATE_SUCCESS: {
      const { dataListMyDate } = Immutable.asMutable(state);
      const { data, params } = action;
      const newMyDate = dataListMyDate.map(itm => {
        if (itm.id === params.id) {
          return data[0];
        }
        return itm;
      });

      if (newMyDate) {
        return state.merge({ dataListMyDate: newMyDate });
      }
      return state;
    }
    default:
      return state;
  }
}
